import actionTypes from '../../constants/actions/importarPedidosExcel/importarPedidosExcel'

export function submitImportarPedidosExcel (value) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_PEDIDOS_EXCEL,
    value
  }
}

export function submitImportarPedidosExcelSuccess (listImportarPedidosExcel) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_PEDIDOS_EXCEL_SUCCESS,
    listImportarPedidosExcel
  }
}

export function abrirModalImportarPedidosExcel () {
  return {
    type: actionTypes.ABRIR_MODAL_IMPORTAR_PEDIDOS_EXCEL
  }
}

export function cerrarModalImportarPedidosExcel () {
  return {
    type: actionTypes.CERRAR_MODAL_IMPORTAR_PEDIDOS_EXCEL
  }
}

export function subirArchivosImportarPedidosExcel (archivoExcel) {
  return {
    type: actionTypes.SUBIR_ARCHIVOS_IMPORTAR_PEDIDOS_EXCEL,
    archivoExcel
  }
}

export function descargarPlantillaExcelPedidosExcel () {
  return {
    type: actionTypes.DESCARGAR_PLANTILLA_EXCEL_PEDIDOS_EXCEL
  }
}

export default {
  submitImportarPedidosExcel,
  abrirModalImportarPedidosExcel,
  cerrarModalImportarPedidosExcel,
  subirArchivosImportarPedidosExcel,
  submitImportarPedidosExcelSuccess,
  descargarPlantillaExcelPedidosExcel
}